// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowDashUp(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowDashUp" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8626 22V19.1928H13.4174V22H10.8626ZM10.8654 17.1515L10.8563 13.0688H13.4078L13.4169 17.1515H10.8654ZM12.1328 2L19.242 8.70068V8.9216L17.5446 10.55L13.4119 6.69454L13.4119 11.0275H10.8571L10.8571 6.70265L6.81296 10.5518L5 8.81132L12.1328 2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowDashUp.js.map